import { render } from "./MenuIdioma.vue?vue&type=template&id=3c317f07"
import script from "./MenuIdioma.vue?vue&type=script&lang=js"
export * from "./MenuIdioma.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__